import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

type ModalVersion = 'v1' | 'v2';
@Component({
  selector: 'modal',
  standalone: true,
  imports: [NgIf, NgClass],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {


  @Input() closeOnOutsideClick = false;
  @Input() displayModal = false;
  @Input() hideCloseIcon = false;
  @Input() hideTitleDivider = false;
  @Input() version: ModalVersion = 'v1';

  @Output() onClose = new EventEmitter<boolean>();

  close() {
    this.displayModal = !this.displayModal;
    this.onClose.emit(this.displayModal);
  }

  onClickOutside($event: any) {
    if(this.closeOnOutsideClick && $event.target.classList.contains('modal')) {
      this.onClose.emit(this.displayModal);
      this.close();
    }
  }

  get checkVersion() {
    return this.version === 'v2' && !this.hideTitleDivider;
  }

}
